import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";

// aiim.base
import ItemReference from "../../../../../aiim/base/ItemReference";

// aiim.datasets
import FieldNames from "../../../../../aiim/datasets/FieldNames";

// aiim.util
import { getAttributeValue } from "../../../../../aiim/util/aiimUtil";

// common.components
import { ModalController } from "../../../../../common/components/Modal";

// common.components.MultipleAssignments
import { getAttributes } from "../../../../../spaceplanner/components/common/MultipleAssignments/multipleAssignmentsUtil";

// components.util
import * as component from "../../../../util/component";
import Icons from "../../../../util/Icons";

// components.main.More.Actions.BookWorkspace
import BookingConfirmed from "./BookingConfirmed";
import BookingDetails from "./BookingDetails";

// components.main.More.Actions.BookWorkspace.WorkspaceReservation
import { 
  getLoggedInUser, 
  login,
  getAccessToken, 
  bookWorkspace, 
  getBookingSchedule
} from "./WorkspaceReservation/OfficeHotelingInterface";
import { 
  getAreaName, 
  getBookingSystem, 
  getBookingSystemType 
} from "./WorkspaceReservation/workspaceReservationUtil";
import { verifyMultipleBookings } from "./BookWorkspaceUtil";

// context
import Context from "../../../../../context/Context";
import Topic from "../../../../../context/Topic";

// redux
import Rdx from "../../../../../redux/Rdx";

// util
import { isNetworkError } from "../../../../../util/networkUtil";

// Calcite
import ServicesIcon from "calcite-ui-icons-react/ServicesIcon";

const CardCSS = {
  main: "i-available-unit",
  title: "i-title",
  unitInfo: "i-unit-info",
  spaceType: "i-space-type"
}

export default class AvailableUnitCard extends React.Component {
  _componentId;
  _itemRef;
  bookingSystem = getBookingSystem();

  constructor(props) {
    super(props);
    const { unit } = this.props;
    const attributes = unit.attributes;

    const spaceType = getAttributeValue(attributes, FieldNames.UNITS_USE_TYPE);
    const unitName = getAttributeValue(attributes, FieldNames.NAME);
    const scheduleEmail = getAttributeValue(attributes, FieldNames.SCHEDULE_EMAIL);
    let levelName = getAttributeValue(attributes, FieldNames.LEVEL_NAME);
    let facilityName = getAttributeValue(attributes, FieldNames.FACILITY_NAME);
    const unitsDataset = Context.instance.aiim.datasets.units;
    if (unitsDataset) {
      const levelData = unitsDataset.getLevelData(unit);
      if (levelData && levelData.levelName) levelName = levelData.levelName;
      if (levelData && levelData.facilityName) facilityName = levelData.facilityName;
    }

    this.state = component.newState({
      areaName: null,
      spaceType,
      unitName,
      scheduleEmail,
      levelName,
      facilityName
    });
    this._componentId = component.nextId("hotel-item-")
    this._itemRef = React.createRef()
  }

  componentDidMount() {
    component.own(this, [
      Topic.subscribe(Topic.InfoPanelClosed, params => {
        if (this._componentId === params.componentId) {
          this._focus()
        }
      })
    ])
  }

  getFeature() {
    return this.props.unit;
  }

  _focus() {
    if (this._itemRef && this._itemRef.current && this._itemRef.current.focus) {
      this._itemRef.current.focus()
    }
  }

  onClick = () => {
    const source = Context.instance.aiim.datasets.units.getSource()
    const feature = this.props.unit
    const item = new ItemReference()
    item.fromSearchResult(source.key, { feature: feature, name: source.getTitle(feature) })
    Topic.publish(Topic.ShowSearchResult, {
      sourceKey: source.key,
      searchResult: item.searchResult,
      zoom: true,
      highlight: true,
      trackRecent: true,
      isBookWorkspacePanel: true,
      componentId: this._componentId
    })
    if (!this.props.hasEmail) {
      const i18n = Context.instance.i18n
      let msg = i18n.more.bookWorkspace.missingEmail
      msg = msg.replace("{unitName}", this.props.name)
      ModalController.showMessage(msg)
    }
  }

  _onKeyDown = (event) => {
    const ENTER = 13;
    const SPACE = 32;

    if (event.keyCode === ENTER || event.keyCode === SPACE) {
      event.preventDefault();
      this.onClick();
    }
  }

  bookClicked = (event) => {
    if(event) event.stopPropagation();

    const unit = this.props.unit;
    const attributes = unit.attributes;
    const areaId = getAttributeValue(attributes, FieldNames.AREA_ID);
    const bookingSystem = this.bookingSystem;
    
    let user = getLoggedInUser(bookingSystem)
    if (user) {
      return getAccessToken(bookingSystem)
      .then(() => {
        return getAreaName(areaId);
      })
      .then((areaName)=> {
        this.setState({
          areaName : areaName,
        }, () => {
          this.renderBookingDetails();
        });
      })
      .catch(error =>{
        console.log("Error in booking workspace.", error);
      })
    } else {
      return login(bookingSystem)
      .then((status)=>{
        if(status === "Success") return getAreaName(areaId);
      })
      .then((areaName)=> {
        this.setState({
          areaName : areaName,
        }, () => {
          this.renderBookingDetails();
        });
      })
      .catch(error =>{
        console.error("Error in booking workspace.", error);
      })
    }
  }

  renderBookingDetails(){
    const node = document.createElement("div");
    document.body.appendChild(node);
    const spaceType = this.state.spaceType;
    const areaName = this.state.areaName;

    const onClose = () => {
      if (node && node.parentNode) {
        node.parentNode.removeChild(node);
        ReactDOM.unmountComponentAtNode(node)
      }
    };

    ReactDOM.render((
      <Provider store={Rdx.store}>
        <BookingDetails
          spaceType={spaceType} 
          areaName={areaName}
          scheduleEmail={this.state.scheduleEmail}
          unitName={this.state.unitName}
          levelName={this.state.levelName}
          facilityName={this.state.facilityName}
          checkAvailability={this.checkAvailability}
          isBookWorkspacePanel={true}
          closePopup={onClose}
          unitFeature={this.getFeature()}
        />
      </Provider>
    ), node);
  }

  renderBookingConfirmed(data, unit) {
    const node = document.createElement("div");
    document.body.appendChild(node);

    const onClose = () => {
      if (node && node.parentNode) {
        node.parentNode.removeChild(node);
        ReactDOM.unmountComponentAtNode(node)
      }
    };

    ReactDOM.render((
      <BookingConfirmed
        unitName={this.state.unitName}
        levelName={this.state.levelName}
        facilityName={this.state.facilityName}
        closePopup={onClose}
        data={data}
        unit={unit}
      />
    ), node);
  }

  confirmBooking = (checkInDate, checkOutDate, allDay) => {
    const type = getBookingSystemType();
    const i18n = Context.getInstance().i18n;
    const options = {
      title: i18n.more.bookWorkspace.multipleBookingTitle,
      message: i18n.more.bookWorkspace.multipleBookingsMessage,
      showOKCancel: true,
      hideCancel: true,
      okLabel: i18n.general.ok
    }
    switch (type) {
      case "office365":
        this.confirmBookingOffice365(checkInDate, checkOutDate);
        break;
      case "esri":
        verifyMultipleBookings(checkInDate, checkOutDate)
        .then((response)=> {
          if(response === "hasExistingBookings") {
            ModalController.confirm(options).then((result)=> {
              if(result && result.ok) this.bookClicked();
            })
          } else {
            this.confirmBookingEsri(checkInDate, checkOutDate, allDay);
          }
        })
        .catch((error) => {
          console.error(error);
          if (error && isNetworkError(error.message)) {
            this.showServerErrorPopup(checkInDate, checkOutDate, allDay);
          }
        })
        break;
      default:
        return;
    }
  }

  confirmBookingOffice365 = (checkInDate, checkOutDate) => {
    // return login(this.bookingSystem)
    // .then((status)=> {
    //   if(status === "Success") return getAccessToken(this.bookingSystem);
    // })
    return getAccessToken(this.bookingSystem).then((token) =>{
      const scheduleEmail = this.state.scheduleEmail;
      const unitName = this.state.unitName;
      const units = Context.instance.aiim.datasets.units;
      const item = new ItemReference();
      item._fromFeature(units.getSource().key, this.props.unit);
      const params = {
        email: scheduleEmail, 
        unitName, 
        checkInDate, 
        checkOutDate, 
        item: item
      }
      return bookWorkspace(this.bookingSystem, token, params);
    })
    .then((response) => {
      if(response){
        this.renderBookingConfirmed();
      }
    })
    .catch((error) =>{
      if (error && isNetworkError(error.message)) {
        this.showServerErrorPopup(checkInDate, checkOutDate);
      }
      console.error(error);
    })
  }

  confirmBookingEsri = (checkInDate, checkOutDate, allDay) => {
    const units = Context.instance.aiim.datasets.units;
    const item = new ItemReference();
    item._fromFeature(units.getSource().key, this.props.unit);
    const params = { 
      unit: this.getFeature(),
      checkIn: checkInDate,
      checkOut: checkOutDate,
      allDay,
      item: item
    };
    return bookWorkspace(this.bookingSystem, null, params)
      .then((data) => {
        Topic.publish(Topic.RenderBookingList, {});
        this.renderBookingConfirmed(data, params.unit);
      })
      .catch((e) => {
        if (e && isNetworkError(e.message)) {
          this.showServerErrorPopup(checkInDate, checkOutDate, allDay);
        } else {
          const i18n = Context.getInstance().i18n;
          let title = i18n.more.bookWorkspace.workspaceUnavailableTitle;
          title = title.replace("{unitName}", this.state.unitName);
          let errorMessage = i18n.more.bookWorkspace.workspaceUnavailable;
          errorMessage = errorMessage.replace("{unitName}", this.state.unitName);
          ModalController.confirm({
            isError: true,
            title: title,
            message: errorMessage,
            submessage: null,
            hideCancel: true
          });
        }
        console.error(e);
      });
  }

  checkAvailability = (checkInDate, checkOutDate, allDay) => {
    const type = getBookingSystemType();
    switch (type) {
      case "office365":
        this.checkAvailabilityOffice365(checkInDate, checkOutDate);
        break;
      case "esri":
        this.checkAvailabilityEsri(checkInDate, checkOutDate, allDay);
        break;
      default:
        return;
    }
  }

  checkAvailabilityOffice365 = (checkInDate, checkOutDate) => {
    // return login(this.bookingSystem)
    // .then((status)=> {
    //   if(status === "Success") return getAccessToken(this.bookingSystem);
    // })
    return getAccessToken(this.bookingSystem).then((token) =>{
      const scheduleEmail = this.state.scheduleEmail;
      const params = {
        schedules : [scheduleEmail],
        startTime : {
          dateTime : checkInDate,
          timeZone: "UTC"
        },
        endTime : {
          dateTime : checkOutDate,
          timeZone: "UTC"
        }
      }
      return getBookingSchedule(this.bookingSystem, token, params);
    })
    .then((availability)=> {
      if(availability && availability.value){
        const scheduleItemsLength = availability.value[0].scheduleItems.length;
        if(scheduleItemsLength === 0){
          this.confirmBooking(checkInDate, checkOutDate);
        }else{
          const i18n = Context.getInstance().i18n;
          let title = i18n.more.bookWorkspace.workspaceUnavailableTitle;
          title = title.replace("{unitName}", this.state.unitName);
          let errorMessage = i18n.more.bookWorkspace.workspaceUnavailable;
          errorMessage = errorMessage.replace("{unitName}", this.state.unitName);
          ModalController.confirm({
            isError: true,
            title: title,
            message: errorMessage,
            submessage: null,
            hideCancel:true
          });
        }
      }
    })
    .catch((error) => {
      if (error && isNetworkError(error.message)) {
        this.showServerErrorPopup(checkInDate, checkOutDate);
      } else {
        const i18n = Context.getInstance().i18n;
        let title = i18n.more.bookWorkspace.workspaceUnavailableTitle;
        let errorMessage = i18n.more.bookWorkspace.workspaceUnavailable;
        errorMessage = errorMessage.replace("{unitName}", this.state.unitName);
        ModalController.confirm({
          isError: true,
          title: title,
          message: errorMessage,
          submessage: null,
          hideCancel:true
        });
      }
      console.error(error);
    })
  }

  checkAvailabilityEsri = (checkInDate, checkOutDate, allDay) => {
    const unit = this.getFeature();
    const attributes = getAttributes(unit);
    const unitId = getAttributeValue(attributes, FieldNames.UNIT_ID);
    const params = { checkInDate, checkOutDate, unitId };

    return getBookingSchedule(this.bookingSystem, null, params)
      .then((availableUnits) => {
        if (availableUnits.length === 1 && availableUnits[0] === unitId) {
          this.confirmBooking(checkInDate, checkOutDate, allDay);
        } else {
          const i18n = Context.getInstance().i18n;
          let title = i18n.more.bookWorkspace.workspaceUnavailableTitle;
          title = title.replace("{unitName}", this.state.unitName);
          let errorMessage = i18n.more.bookWorkspace.workspaceUnavailable;
          errorMessage = errorMessage.replace("{unitName}", this.state.unitName);
          ModalController.confirm({
            isError: true,
            title: title,
            message: errorMessage,
            submessage: null,
            hideCancel: true
          });
        }
      })
      .catch((error) => {
        if (error && isNetworkError(error.message)) {
          this.showServerErrorPopup(checkInDate, checkOutDate, allDay);
        } else {
          const i18n = Context.getInstance().i18n;
          let title = i18n.more.bookWorkspace.workspaceUnavailableTitle;
          let errorMessage = i18n.more.bookWorkspace.workspaceUnavailable;
          errorMessage = errorMessage.replace("{unitName}", this.state.unitName);
          ModalController.confirm({
            isError: true,
            title: title,
            message: errorMessage,
            submessage: null,
            hideCancel:true
          });
        }
        console.error(error);
      });
  }

  showServerErrorPopup = (checkInDate, checkOutDate, allDay) => {
    const i18n = Context.getInstance().i18n;
    const options = {
      title: i18n.more.bookWorkspace.error,
      message: "Unable to book the hotel. Check your network connection and try again.",
      okLabel: i18n.more.bookWorkspace.tryAgain,
      showOkCancel: true,
      hideCancel : false,
      closeOnOK: true,
      cancelLabel: i18n.more.bookWorkspace.cancel
    };
    ModalController.confirm(options)
    .then(result => {
      if(result.ok) {
        this.confirmBooking(checkInDate, checkOutDate, allDay);
      }
    })
    .catch((error) => {
      if (error && isNetworkError(error.message)) {
        this.showServerErrorPopup(checkInDate, checkOutDate, allDay);
      } else {
        Topic.publish(Topic.publishErrorUpdatingData());
      }
      console.error(error);
    })
  }

  render() {
    const i18n = Context.getInstance().i18n;
    const mainCSS = this.props.hasEmail ? CardCSS.main : CardCSS.main + " no-email"
    const pinIcon = "libs/calcite-ui-icons/icons/sprite-16.svg#pin-16"
    // const deskIcon = "libs/calcite-ui-icons/icons/sprite-16.svg#desk-16"
    return (
      <div 
        ref={this._itemRef} 
        role="button"
        className={mainCSS} 
        onClick={this.onClick} 
        tabIndex="0"
        onKeyDown={this._onKeyDown}
      >
        <div>
          <div className={CardCSS.title}>{this.props.name}</div>
          <div className={CardCSS.unitInfo}>
            <svg><use href={pinIcon}></use></svg>
            <div>{this.props.description}</div>
          </div>
          <div className={CardCSS.spaceType}>
            {Icons.desk()}
            <div>{this.props.spaceType}</div>
          </div>
        </div>
        <button onClick={this.bookClicked}> 
          <ServicesIcon />
          {i18n.more.bookWorkspace.bookButton}
        </button>
      </div>
    )
  }
}